import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent } from 'vue';
import PracticeSelector from '@/pages/profile/practice-selector.vue';
import { useApiErrorToast } from '@/modules/useApiErrorToast';
import { apprenticePeriodRules, practiceValidator } from '@/utils/profileUtils';
import { useRepositories } from '@/plugins/repositories';
import { useTelemetry } from '@/plugins/telemetry';
import { useAuth } from '@/plugins/auth';
var stringToNumber = function stringToNumber(numString) {
  if (numString === '') return null;
  var numberedString = Number(numString);
  if (isNaN(numberedString)) return null;
  return numberedString;
};
var isValidSelection = function isValidSelection(obj) {
  if (obj.withExperience && obj.experienceId === -1) {
    return false;
  }
  return obj.practiceId !== -1;
};
export default defineComponent({
  components: {
    PracticeSelector: PracticeSelector
  },
  setup: function setup() {
    var _user$profile$apprent;
    var telemetry = useTelemetry();
    var route = useRoute();
    var repositories = useRepositories();
    var _useApiErrorToast = useApiErrorToast(),
      showRetriableErrorToast = _useApiErrorToast.showRetriableErrorToast;
    var loadingMe = ref(true);
    var editing = ref(false);
    var apprenticePeriod = ref('');
    var apprenticePeriodValid = ref(false);
    var practicesValid = ref(false);
    var practices = ref([]);
    var availablePracticeOptions = ref([]);
    var experienceOptions = ref([]);
    var organizationType = ref(null);
    var loadingOrganizationType = ref(true);
    repositories.users.getOrganizationType().then(function (res) {
      organizationType.value = res;
      loadingOrganizationType.value = false;
    });
    var isLawOffice = computed(function () {
      return organizationType.value === 'law-office';
    });
    var isProfessionalOffice = computed(function () {
      return organizationType.value === 'professional-office';
    });
    var practiceLabel = computed(function () {
      return isLawOffice.value ? 'プラクティス' : '主なリサーチ分野';
    });
    var submitButtonDisabled = computed(function () {
      return isProfessionalOffice ? !practicesValid : !apprenticePeriodValid || !practicesValid;
    });
    var blankPracticeOption = {
      name: '選択してください',
      id: -1,
      isExperienceRequired: false
    };
    var blankExperienceOption = {
      name: '選択してください',
      id: -1
    };
    var loadingPracticesForUserProfile = ref(true);
    repositories.users.listPracticesForUserProfile().then(function (res) {
      availablePracticeOptions.value = res.practices;
      experienceOptions.value = res.experiences;
      loadingPracticesForUserProfile.value = false;
    });
    var validate = function validate(practices) {
      practicesValid.value = practiceValidator(practices);
    };
    var _useAuth = useAuth(),
      user = _useAuth.user;
    apprenticePeriod.value = ((_user$profile$apprent = user.profile.apprenticePeriod) === null || _user$profile$apprent === void 0 ? void 0 : _user$profile$apprent.toString()) || '';
    practices.value = user.profile.practices;
    loadingMe.value = false;
    validate(practices.value);
    var addPractice = function addPractice() {
      practices.value = [].concat(_toConsumableArray(practices.value), [{
        withExperience: false,
        practiceId: -1,
        practiceName: '選択してください'
      }]);
      validate(practices.value);
    };
    var deletePractice = function deletePractice(index) {
      practices.value = practices.value.filter(function (_, _index) {
        return index !== _index;
      });
      validate(practices.value);
    };
    var submit = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _user$profile$apprent2;
        var _useAuth2, user;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              practices.value = practices.value.filter(isValidSelection);
              _context.prev = 1;
              _context.next = 4;
              return repositories.users.putUserProfile(stringToNumber(apprenticePeriod.value), practices.value.map(function (selection) {
                return selection.withExperience ? {
                  practiceId: selection.practiceId,
                  experienceId: selection.experienceId
                } : {
                  practiceId: selection.practiceId
                };
              }));
            case 4:
              _context.next = 11;
              break;
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](1);
              showRetriableErrorToast('プロフィールの送信に失敗しました');
              telemetry.sendErrorTelemetry(_context.t0, route);
              return _context.abrupt("return");
            case 11:
              _useAuth2 = useAuth(), user = _useAuth2.user;
              apprenticePeriod.value = ((_user$profile$apprent2 = user.profile.apprenticePeriod) === null || _user$profile$apprent2 === void 0 ? void 0 : _user$profile$apprent2.toString()) || '';
              practices.value = user.profile.practices;
              validate(practices.value);
              editing.value = false;
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 6]]);
      }));
      return function submit() {
        return _ref.apply(this, arguments);
      };
    }();
    var updatePracticeIdHandler = function updatePracticeIdHandler(targetIndex, practiceId) {
      practices.value = practices.value.map(function (practice, index) {
        if (index !== targetIndex) return practice;
        var practiceOption = availablePracticeOptions.value.find(function (option) {
          return option.id === practiceId;
        }) || blankPracticeOption;
        if (practiceOption.isExperienceRequired) {
          if (practice.withExperience) {
            return _objectSpread(_objectSpread({}, practice), {}, {
              practiceId: practiceOption.id,
              practiceName: practiceOption.name
            });
          }
          return {
            withExperience: true,
            practiceId: practiceOption.id,
            practiceName: practiceOption.name,
            experienceId: blankExperienceOption.id,
            experienceName: blankExperienceOption.name
          };
        }
        return {
          withExperience: false,
          practiceId: practiceOption.id,
          practiceName: practiceOption.name
        };
      });
      validate(practices.value);
    };
    var updateExperienceIdHandler = function updateExperienceIdHandler(targetIndex, experienceId) {
      practices.value = practices.value.map(function (practice, index) {
        if (index !== targetIndex || practice.withExperience === false) return practice;
        var experienceOption = experienceOptions.value.find(function (option) {
          return option.id === experienceId;
        }) || blankPracticeOption;
        return _objectSpread(_objectSpread({}, practice), {}, {
          experienceId: experienceOption.id,
          experienceName: experienceOption.name
        });
      });
      validate(practices.value);
    };
    var practiceOptions = computed(function () {
      return availablePracticeOptions.value.filter(function (option) {
        return !practices.value.some(function (p) {
          return p.practiceId === option.id;
        });
      });
    });
    var loading = computed(function () {
      return loadingMe.value || loadingOrganizationType.value || loadingPracticesForUserProfile.value;
    });
    return {
      editing: editing,
      apprenticePeriod: apprenticePeriod,
      practiceOptions: practiceOptions,
      availablePracticeOptions: availablePracticeOptions,
      experienceOptions: experienceOptions,
      addPractice: addPractice,
      deletePractice: deletePractice,
      submit: submit,
      practices: practices,
      updatePracticeIdHandler: updatePracticeIdHandler,
      updateExperienceIdHandler: updateExperienceIdHandler,
      apprenticePeriodRules: apprenticePeriodRules,
      practiceLabel: practiceLabel,
      apprenticePeriodValid: apprenticePeriodValid,
      practicesValid: practicesValid,
      loading: loading,
      isProfessionalOffice: isProfessionalOffice,
      submitButtonDisabled: submitButtonDisabled
    };
  }
});